const AmericanWaltz = {
    name: "American Waltz",
    bpm: 198,
    signature: "6/8",
    introMeasures: 8,
    pattern: [

    ]
};

export default AmericanWaltz;